// extracted by mini-css-extract-plugin
export default {"title":"styles_title__8uzS4","buttonWrapper":"styles_buttonWrapper__lQoBV","customButton":"styles_customButton__GGn7b"};